module.exports = __webpack_public_path__ + "src/assets/img/show_car_on.fcf5bc9a.svg";